export const ROOT_ROUTE = '/';
export const CLAIMS360_ROUTE = '/claims360';
export const ASSOCIATE_ROUTE = '/associate';